function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#175664}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Chat_nav_icon",
  "data-name": "Chat nav icon",
  transform: "translate(-99.571 -711)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Chat_nav_icon-2",
  "data-name": "Chat nav icon",
  transform: "translate(-2.429 -1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4445",
  "data-name": "Group 4445",
  transform: "translate(102 712)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4441",
  "data-name": "Group 4441",
  transform: "translate(.619 9.334)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4440",
  "data-name": "Group 4440"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4439",
  "data-name": "Group 4439"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4438",
  "data-name": "Group 4438"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2825",
  "data-name": "Path 2825",
  className: "cls-1",
  d: "M-229.157 15.056h-12.228a1.124 1.124 0 0 1-1.125-1.125 1.124 1.124 0 0 1 1.125-1.125h12.228a1.124 1.124 0 0 1 1.125 1.125 1.125 1.125 0 0 1-1.125 1.125z",
  transform: "translate(242.51 -12.807)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4443",
  "data-name": "Group 4443",
  transform: "translate(6.455)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4442",
  "data-name": "Group 4442"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2826",
  "data-name": "Path 2826",
  className: "cls-1",
  d: "M-231.377 25.423a10.422 10.422 0 0 1-5.4-1.5 1.069 1.069 0 0 1-.362-1.468 1.066 1.066 0 0 1 1.468-.36 8.292 8.292 0 0 0 4.292 1.194 8.33 8.33 0 0 0 8.322-8.321 8.331 8.331 0 0 0-8.322-8.322 8.294 8.294 0 0 0-4.318 1.21 1.066 1.066 0 0 1-1.468-.355 1.068 1.068 0 0 1 .355-1.469 10.427 10.427 0 0 1 5.43-1.523 10.471 10.471 0 0 1 10.459 10.458 10.47 10.47 0 0 1-10.456 10.456z",
  transform: "translate(237.32 -4.507)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4444",
  "data-name": "Group 4444",
  transform: "translate(0 6.348)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2827",
  "data-name": "Path 2827",
  className: "cls-1",
  d: "M-238.506 18.373a1.067 1.067 0 0 1-.756-.313l-3.8-3.8 3.8-3.8a1.069 1.069 0 0 1 1.511 0 1.069 1.069 0 0 1 0 1.51l-2.287 2.287 2.287 2.286a1.07 1.07 0 0 1 0 1.511 1.069 1.069 0 0 1-.755.319z",
  transform: "translate(243.06 -10.152)"
})))));

function SvgSignUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.858,
    height: 20.916,
    viewBox: "0 0 22.858 20.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp);
export default __webpack_public_path__ + "static/media/SignUp.16eac9b3.svg";
export { ForwardRef as ReactComponent };